var React = require('react');

function NextSection (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 9.09375 4.78125 L 7.6875 6.21875 L 17.46875 16 L 7.6875 25.78125 L 9.09375 27.21875 L 20.3125 16 Z M 16.09375 4.78125 L 14.6875 6.21875 L 24.46875 16 L 14.6875 25.78125 L 16.09375 27.21875 L 27.3125 16 Z","fill":"#000000"}));
}

NextSection.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000"};

module.exports = NextSection;

NextSection.default = NextSection;
